(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestovaya-blog-journal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.nvbjReady === 'true') return;
      root.dataset.nvbjReady = 'true';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('nvbj--animate') || reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
      root.classList.add('is-ready');
      var cols = parseInt(getComputedStyle(root).getPropertyValue('--nvbj-cols'), 10) || 1;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      root.querySelectorAll('[data-nvbj-item]').forEach(function (item, i) {
        item.style.transitionDelay = ((i % cols) * 80) + 'ms';
        io.observe(item);
      });
      var active = root.querySelector('.nvbj__tag.is-active');
      if (active && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
        active.parentElement.scrollLeft = active.offsetLeft - 16;
      }
    }
    function initAll() { document.querySelectorAll('[data-nvbj]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-nvbj]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestovaya-collections-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.nvclReady === 'true') return;
      root.dataset.nvclReady = 'true';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-nvcl-item]'));
      var head = root.querySelector('.nvcl__head');

      if (root.classList.contains('nvcl--animate') && !reduce && 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
        root.classList.add('is-ready');
        var cols = parseInt(getComputedStyle(root).getPropertyValue('--nvcl-cols'), 10) || 1;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
        if (head) io.observe(head);
        items.forEach(function (item, i) {
          item.style.transitionDelay = ((i % cols) * 70) + 'ms';
          io.observe(item);
        });
      }

      var input = root.querySelector('[data-nvcl-filter]');
      var status = root.querySelector('[data-nvcl-status]');
      var empty = root.querySelector('[data-nvcl-empty]');
      if (!input) return;

      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var visible = 0;
        items.forEach(function (item) {
          var match = !q || (item.getAttribute('data-title') || '').indexOf(q) !== -1;
          item.hidden = !match;
          if (match) {
            visible += 1;
            item.classList.add('is-in');
          }
        });
        if (empty) empty.hidden = visible !== 0;
        if (status) status.textContent = q ? visible + ' of ' + items.length + ' shown' : '';
      });
    }

    function initAll() {
      document.querySelectorAll('[data-nvcl]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-nvcl]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestovaya-contact-connect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.nvctReady === 'true') return;
      root.dataset.nvctReady = 'true';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (root.classList.contains('nvct--animate') && !reduce && 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
        root.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-in');
              io.disconnect();
            }
          });
        }, { threshold: 0.12 });
        io.observe(root);
      }

      var message = root.querySelector('[data-nvct-message]');
      var count = root.querySelector('[data-nvct-count]');
      if (message && count) {
        var update = function () { count.textContent = message.value.length; };
        message.addEventListener('input', update);
        update();
      }

      var focusTarget = root.querySelector('[data-nvct-success]') || root.querySelector('[data-nvct-alert]');
      if (focusTarget) {
        root.classList.add('is-in');
        setTimeout(function () { focusTarget.focus({ preventScroll: false }); }, 60);
      }

      var form = root.querySelector('form.nvct__form') || root.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', function (event) {
        var fields = form.querySelectorAll('[required]');
        var firstInvalid = null;
        fields.forEach(function (field) {
          var valid = field.value.trim() !== '' && (field.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim()));
          field.setAttribute('aria-invalid', valid ? 'false' : 'true');
          if (!valid && !firstInvalid) firstInvalid = field;
        });
        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
          return;
        }
        var btn = form.querySelector('[data-nvct-submit]');
        if (btn) btn.setAttribute('aria-busy', 'true');
      });
      form.querySelectorAll('[required]').forEach(function (field) {
        field.addEventListener('input', function () {
          if (field.getAttribute('aria-invalid') === 'true' && field.value.trim() !== '') field.setAttribute('aria-invalid', 'false');
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-nvct]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-nvct]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nestovaya-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.nvpgReady === 'true') return;
      root.dataset.nvpgReady = 'true';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (root.classList.contains('nvpg--animate') && !reduce && 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
        root.classList.add('is-ready');
        var cols = parseInt(getComputedStyle(root).getPropertyValue('--nvpg-cols'), 10) || 1;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
        root.querySelectorAll('[data-nvpg-item]').forEach(function (item, i) {
          item.style.transitionDelay = ((i % cols) * 60) + 'ms';
          io.observe(item);
        });
      }

      var activeNav = root.querySelector('.nvpg__nav-link.is-active');
      if (activeNav && activeNav.parentElement && activeNav.closest('.nvpg__nav-list')) {
        var list = activeNav.closest('.nvpg__nav-list');
        if (list.scrollWidth > list.clientWidth) {
          list.scrollLeft = activeNav.parentElement.offsetLeft - 16;
        }
      }

      var drop = root.querySelector('[data-nvpg-drop]');
      if (drop) {
        document.addEventListener('click', function (event) {
          if (drop.open && !drop.contains(event.target)) drop.open = false;
        });
        drop.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && drop.open) {
            drop.open = false;
            var summary = drop.querySelector('summary');
            if (summary) summary.focus();
          }
        });
      }

      var priceForm = root.querySelector('[data-nvpg-price-form]');
      if (priceForm) {
        priceForm.addEventListener('submit', function () {
          var minInput = priceForm.querySelector('[data-nvpg-min]');
          var maxInput = priceForm.querySelector('[data-nvpg-max]');
          var limit = maxInput ? parseFloat(maxInput.getAttribute('max')) : NaN;
          var clean = function (input) {
            if (!input || input.value === '') return null;
            var v = parseFloat(String(input.value).replace(',', '.'));
            if (isNaN(v) || v < 0) v = 0;
            if (!isNaN(limit) && v > limit) v = limit;
            v = Math.round(v * 100) / 100;
            input.value = v;
            return v;
          };
          var minVal = clean(minInput);
          var maxVal = clean(maxInput);
          if (minVal !== null && maxVal !== null && minVal > maxVal) {
            minInput.value = maxVal;
            maxInput.value = minVal;
          }
          [minInput, maxInput].forEach(function (input) {
            if (input && input.value === '') input.removeAttribute('name');
          });
        });
      }

      var sortSelect = root.querySelector('[data-nvpg-sort]');
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var form = sortSelect.form;
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-nvpg]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-nvpg]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
